module.exports = __webpack_public_path__ + "img/ru-da.2d08a4f9.svg";